module.exports = __webpack_public_path__ + "img/tablet-hamburgueria.ba57940e.png";